import { render, staticRenderFns } from "./PageSimple.vue?vue&type=template&id=2a6e3706&"
import script from "./PageSimple.vue?vue&type=script&lang=js&"
export * from "./PageSimple.vue?vue&type=script&lang=js&"
import style0 from "./PageSimple.vue?vue&type=style&index=0&id=2a6e3706&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports